import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { BaseURL } from '../../../config/apiUrl';
import { Get } from '../../../Axios/AxiosFunctions';
import SideBarSkeleton from '../../../Component/SideBarSkeleton';

// One lookup per sign-in: which redesigned pages this person can open.
let cache = { token: undefined, value: null, wait: null };
export function useBeta() {
  const { access_token: token, company_id: companyId } = useSelector((s) => s?.authReducer || {});
  const [v, setV] = useState(cache.token === token ? cache.value : null);
  useEffect(() => {
    if (!token) return;
    if (cache.token === token && cache.value) return setV(cache.value);
    if (cache.token !== token || !cache.wait) {
      cache = { token, value: null, wait: Get(BaseURL('beta/me'), token, companyId, false).then((r) => r?.data?.data || { staff: false, client: false }) };
    }
    cache.wait.then((x) => {
      cache.value = x;
      setV(x);
    });
  }, [token, companyId]);
  return v;
}

/** The redesigned pages (beta) open only for the people named for testing, until they are switched on. */
export default function BetaGate({ children }) {
  const beta = useBeta();
  if (!beta) return null;
  if (beta.staff) return children;
  return (
    <SideBarSkeleton>
      <div style={{ padding: 30 }}>
        <h3>This page is not available yet</h3>
        <p>The new pages are being tested by a few people first. Use the current pages in the menu.</p>
      </div>
    </SideBarSkeleton>
  );
}
